import { ReactNode } from "react";
import { Box } from "@mui/material";
import { TOP_HEADER_HEIGHT } from "../top_header/const";

export const PageFrame = (props: { children?: ReactNode }): JSX.Element => {
  return (
    <Box
      sx={{
        height: `calc(100vh - var(--top-header-height, ${TOP_HEADER_HEIGHT}px))`,
        pr: 1,
        mb: 2,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
      aria-label="page-frame"
    >
      {props.children}
    </Box>
  );
};
